import { Soribot } from "./Soribot";
import { DataSourceType } from "./SoribotSource";
import { BotType, SoribotSubType } from "./local/Types";

export class BotMessage {
  static COL = 'soribotmessages';

  public started: Date = new Date();
  public timeVectorDBCall: number | null = null;    // MS
  public timeLLMCall: number | null = null;         // MS
  public timeTotal: number | null = null;       // MS

  public llmPrompt: string | null = null;
  public llmModelName: string;
  public llmTemperature: number;
  public llmResponse: string | null = null; // should be name to response but too late to change.
  public suggestionId: string | null = null; // should be name to response but too late to change.

  public promptTemplate: string | null;
  public systemInstruction: string | null;
  public soribotName: string;
  public soribotId: string;
  public workspaceId: string;
  public botType: BotType; // Should always be ai-soribot but you never know in the future.
  public subType: SoribotSubType;

  public errorMessage: string | null = null;
  public chunkInfos: ChunkInfo[] | null = null;

  public userId?: string | null = null;
  public endpoint?: AskBotEndpoint;
  
  constructor(public id: string,
    bot: Soribot,
    public userPrompt: string
  ) {
    this.soribotName = bot.name;
    this.soribotId = bot.id;
    this.botType = bot.type;
    this.subType = bot.subType ?? 'retrieval';
    this.llmModelName = bot.llmModelName;
    this.llmTemperature = bot.llmTemperature ?? 0;
    this.promptTemplate = bot.promptTemplate;
    this.systemInstruction = bot.systemInstruction;
    this.workspaceId = bot.workspaceId;
  }
}

export class ChunkInfo {
  constructor(public sourceId: string, public title: string, public chunkText: string, public chunkNr: number, public type: DataSourceType, public distance?: number) {
  }
}
export type AskBotEndpoint = 'app' | 'api' | 'public';
